import { UserRepo, UpdateUserData } from "../domain/UserRepo";

export interface UpdateUserScreenData {
  ui_loading: boolean;
  error_message: string;
  success_message: string;
}

export class UpdateUserCommand {
  constructor(
    private userRepo: UserRepo,
    private screenData: UpdateUserScreenData
  ) {}

  async execute(userId: number, userData: UpdateUserData): Promise<boolean> {
    this.screenData.ui_loading = true;
    this.screenData.error_message = '';
    this.screenData.success_message = '';

    try {
      const result = await this.userRepo.update(userId, userData);

      if (result.error) {
        this.screenData.error_message = result.error;
        return false;
      }

      this.screenData.success_message = 'Usuario actualizado con éxito';
      return true;
    } catch (error: any) {
      this.screenData.error_message = error.message || 'Error al actualizar usuario';
      return false;
    } finally {
      this.screenData.ui_loading = false;
    }
  }
}
